import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { ConventionRegistrationSectoralMeetingExtension } from 'app/models/extensions/convention-registration-sectoral-meeting-extension.model';
import { SectoralMeeting } from 'app/models/sectoral-meeting.model';
import { MRMValidators } from '@mrm/core';

export class ConventionRegistrationSectoralMeeting extends ConventionRegistrationSectoralMeetingExtension {
  conventionRegistrationSectoralMeetingDBID: number = 0;
  conventionRegistrationDBID: number = 0;
  sectoralMeetingDBID?: number = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionRegistration: ConventionRegistration = null;
  sectoralMeeting: SectoralMeeting = null;

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      conventionRegistrationSectoralMeetingDBID: new FormControl({ value: 0, disabled: disableAll }),
      conventionRegistrationDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      sectoralMeetingDBID: new FormControl({ value: null, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),

    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'conventionregistration':
            form.addControl('conventionRegistration', ConventionRegistration.getForm(disableAll)); break;
          case 'sectoralmeeting':
            form.addControl('sectoralMeeting', SectoralMeeting.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of ConventionRegistrationSectoralMeeting. Please use one of the following navigational property: 'conventionRegistration' | 'sectoralMeeting'`);
        }
      }
    }

    return form;
  }
}